import React, { useEffect, useState, useMemo, useRef, useCallback } from "react"
import { BsImageAlt, BsPencil } from "react-icons/bs"
import InlineTextField from "../../Components/InLineTextField"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import { datatableTheme } from "../../Common/dataTableTheme"
import DataTable, { createTheme } from "react-data-table-component"
import axios from "axios"
import Dialog from "../../Components/Dialog"
import { FaEye } from "react-icons/fa";
import { FaTruckFast } from "react-icons/fa6";
import { HiPrinter } from "react-icons/hi2";
import { useFormik } from "formik"
import * as Yup from 'yup'
import FieldSelect from '../../Components/FieldSelect'
import Button from '../../Components/Button'
import logo from '../../Assets/Images/rklogo.png'

createTheme('defaultLight', datatableTheme.default)
createTheme('defaultDark', datatableTheme.dark)

const initialShipForm = {
    orderStatus: 0,
    invoiceId: '',
    orderId: ''
}

const StoreOrders = () => {

    const [loading, setLoading] = useState(true)
    const [filter, setFilter] = useState('')
    const [orderList, setOrderList] = useState([])
    const history = useHistory()
    const [page, setPage] = useState(1)
    const invoiceRef = useRef()
    const [orderStatus, setOrderStatus] = useState([])
    const [statusMenu, setStatusMenu] = useState([])
    const userDetails = useSelector((state) => state.auth.userDetails)
    const [openShipmentDialog, setOpenShipmentDialog] = useState(false)
    const [orderDetails, setOrderDetails] = useState()
    const [count, setCount] = useState(0)
    const [openViewOrderDialog, setOpenViewOrderDialog] = useState(false)
    const [openPrintOrderDialog, setOpenPrintOrderDialog] = useState(false)
    const accountDetails = useSelector((state) => state.auth.accountDetails)
    const [printOrders, setPrintOrders] = useState([])
    const [orderedProducts, setOrderedProducts] = useState([])
    const [currentRow, setCurrentRow] = useState(null)


    useEffect(() => {
        setLoading(true)
        axios.all([API.get('/order/getOrders'), API.get('/order/getOrderStatus')]).then((axios.spread((orderRes, statusRes) => {
            setLoading(false)
            setOrderList(orderRes.data.data)
            setStatusMenu(statusRes.data.data.map((c) => { return { text: c.orderStatus, value: c.orderStatusId } }))
            setOrderStatus(statusRes.data.data)
        })))
    }, [count])

    const changeAction = (value) => {
        shipForm.setValues({ ...shipForm.values, orderStatus: value.orderStatus, invoiceId: value._id, orderId: value.orderId })
        // setOrderDetails(value)
        setOpenShipmentDialog(true)
    }

    const viewOrder = (value) => {
        API.get(`/order/getOrderDetails/${value.orderId}/${value.sellerId}`).then((orderRes) => {
            if (orderRes.status === 200) {
                setOrderDetails({ value, ...orderRes.data.data.orderDetails })
                setOpenViewOrderDialog(true)
            }
        })
    }

    const printOrder = (value) => {
        API.get(`/order/getOrderDetails/${value.orderId}/${value.sellerId}`).then((orderRes) => {
            if (orderRes.status === 200) {
                setOrderDetails({ value, ...orderRes.data.data.orderDetails })
                setPrintOrders(orderRes.data.data)
                setOpenPrintOrderDialog(true)
                setOpenShipmentDialog(false)
                setOpenViewOrderDialog(false)
            }
        })
    }

    const orderedProductsColumns = useMemo(() => [
        { name: 'S.No', selector: (row, i) => i + 1, initialActive: true, sortable: true, width: '100px' },
        { name: <BsImageAlt />, selector: row => { return <img src={row.images[0].imageUrl} height={20} width={20} alt="img" /> }, initialActive: true, width: '100px' },
        { name: 'Product Name', selector: row => row.productName, initialActive: true, sortable: true },
        { name: 'Brand Name', selector: row => row.brandName, sortable: true },
        { name: 'Model Name', selector: row => row.modelName, sortable: true },
        { name: 'Price', selector: row => row.price, sortable: true },
        { name: 'Quantity', selector: row => row.orderQuantity, sortable: true },
        // { name: 'Order Status', selector: row => { return orderStatus?.filter((x) => x.orderStatusId === row.orderStatus)[0]?.orderStatus }, initialActive: true, sortable: true },
        // {
        //     name: 'Action', selector: row => <motion.div className="px-1 py-1 w-full flex flex-row justify-between cursor-pointer">
        //         <FaEye className="cursor-pointer" onClick={() => viewOrder(row)} />&nbsp;&nbsp;&nbsp;&nbsp;
        //         <HiPrinter className="cursor-pointer" onClick={() => printOrder(row)} />&nbsp;&nbsp;&nbsp;&nbsp;
        //         <FaTruckFast className="cursor-pointer" onClick={() => changeAction(row)} />&nbsp;&nbsp;&nbsp;&nbsp;
        //     </motion.div>
        // }
    ], [])

    const columns = useMemo(() => [
        { name: 'S.No', selector: (row, i) => i + 1, initialActive: true, sortable: true, width: '100px' },
        // { name: <BsImageAlt />, selector: row => { return <img src={row.images[0].imageUrl} height={20} width={20} alt="img" /> }, initialActive: true, width: '100px' },
        { name: 'Order Id', selector: row => row.orderId, initialActive: true, sortable: true },
        // { name: 'Brand Name', selector: row => row.productId.brandName, sortable: true },
        // { name: 'Model Name', selector: row => row.productId.modelName, sortable: true },
        // { name: 'Price', selector: row => row.price, sortable: true },
        // { name: 'Quantity', selector: row => row.orderQuantity, sortable: true },
        { name: 'Order Status', selector: row => { return orderStatus?.filter((x) => x.orderStatusId === row.orderStatus)[0]?.orderStatus }, initialActive: true, sortable: true },
        {
            name: 'Action', selector: row => <motion.div className="px-1 py-1 w-full flex flex-row justify-between cursor-pointer">
                {/* <FaEye className="cursor-pointer" onClick={() => viewOrder(row)} />&nbsp;&nbsp;&nbsp;&nbsp; */}
                <HiPrinter className="cursor-pointer" onClick={() => printOrder(row)} />&nbsp;&nbsp;&nbsp;&nbsp;
                <FaTruckFast className="cursor-pointer" onClick={() => changeAction(row)} />&nbsp;&nbsp;&nbsp;&nbsp;
            </motion.div>
        }
    ], [])

    const filteredcasedetails = useMemo(() => {
        const filterSplit = filter.toLowerCase().split(' ')
        return orderList?.orderList?.filter(c =>
            filterSplit.every(i =>
                Object.keys(c).some(j => c[j]?.toString().toLowerCase().includes(i))
            )
        )
    }, [orderList.orderList, filter])

    const SubHeader = useMemo(() => (
        <div className="flex flex-row items-center">
            <InlineTextField label={"Search"} value={filter} setValue={setFilter} />
        </div>
    ), [filter])// eslint-disable-line

    const shipmentFormSchema = Yup.object().shape({
        orderStatus: Yup.number(),
        invoiceId: Yup.string(),
        orderId: Yup.string()
    })

    const shipForm = useFormik({
        initialValues: initialShipForm,
        validateOnMount: true,
        validationSchema: shipmentFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            API.post('/order/changeOrderStatus', values).then((statRes) => {
                if (statRes.status === 200) {
                    shipForm.resetForm()
                    setOrderDetails({})
                    setOpenShipmentDialog(false)
                    setCount(count + 1)
                }
            })
        }
    })

    const handlePrint = () => {
        // const printContent = invoiceRef.current;
        // const printWindow = window.open('', '', 'width=800,height=600');
        // printWindow.document.write('<html><head><title>Invoice</title>');
        // printWindow.document.write('<style>');
        // printWindow.document.write('body { font-family: Arial, sans-serif; }'); // Add any additional styles here
        // printWindow.document.write('</style>');
        // printWindow.document.write('</head><body >');
        // printWindow.document.write(printContent.outerHTML);
        // printWindow.document.write('</body></html>');
        // printWindow.document.close();
        // printWindow.print();
        var printContents = document.getElementById('invoicePrint').innerHTML;

        document.body.innerHTML = printContents;

        window.print();
    };

    const rowExpanded = (data, row) => {
        setCurrentRow(row.orderId)
        setOrderedProducts(row.products)
        // if (data) {
        //     API.get(`/finance/getPaymentHistory/${orgId}/${row.invoiceId}`).then((historyRes) => {
        //         if (historyRes.status === 200) {
        //             setInvoiceHistory(historyRes.data.data)
        //         }
        //     }).catch((err) => {
        //         dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', type: 'error', active: true }))
        //     })
        // }
    }

    const RowComponent = useCallback(row => {
        return (
            <div className="dark:bg-ldark py-2 px-3" key={row.data._id}>
                {
                    Object.keys(row.data).map(c => (
                        <div className="flex flex-col my-1">
                            <span className="text-xs text-gray-500 dark:text-gray-300">{c.split('_').map(e => (`${e[0].toUpperCase()}${e.slice(1,).toLowerCase()}`)).join(' ')}</span>
                            <span className="text-sm" >{row.data[c]}</span>
                        </div>
                    ))
                }
            </div>
        )
    }, [])

    const NoHistory = () => (
        <div className="my-6 text-sm text-gray-500 dark:text-gray-400">
            {'No products to display'}
        </div>
    )

    const ExpandComponent = useCallback(({ data }) => {
        return (
            <div className="p-4 bg-bluegray-300 dark:bg-ldark">
                {
                    <DataTable columns={orderedProductsColumns} data={orderedProducts} pagination noHeader highlightOnHover persistTableHead
                        selectableRowsHighlight onChangePage={val => setPage(val)} paginationDefaultPage={page} expandableRowsComponent={<RowComponent />} noDataComponent={<NoHistory />} />
                }
            </div>
        )
    }, [orderedProducts]) // eslint-disable-line

    return (
        <>
            {
                loading ? <h1>Loading please wait</h1> : <motion.div className="w-full h-full relative flex flex-col">
                    <motion.div className="grid grid-cols-1 gap-1 sm:grid-cols-1 md:grid-cols-4 xl:grid-cols-4 lg:grid-cols-4">
                        <motion.div className="flex flex-col justify-center items-center h-28 ring-1 ring-[lightGrey] drop-shadow-md px-5 py-2">
                            <motion.div className="text-black font-bold my-2">
                                Total Orders
                            </motion.div>
                            <motion.div className="flex flex-row my-2 justify-between">
                                {orderList && orderList.total}
                            </motion.div>
                        </motion.div>
                        <motion.div className="flex flex-col justify-center items-center h-28 ring-1 ring-[lightGrey] drop-shadow-md px-5 py-2">
                            <motion.div className="text-black font-bold my-2">
                                In Progress
                            </motion.div>
                            <motion.div className="flex flex-row my-2 justify-between">
                                {orderList && orderList.inProgress}
                            </motion.div>
                        </motion.div>
                        <motion.div className="flex flex-col justify-center items-center h-28 ring-1 ring-[lightGrey] drop-shadow-md px-5 py-2">
                            <motion.div className="text-black font-bold my-2">
                                Delivered
                            </motion.div>
                            <motion.div className="flex flex-row my-2 justify-between">
                                {orderList && orderList.delivered}
                            </motion.div>
                        </motion.div>
                    </motion.div>
                    <motion.div className="h-full w-full my-5 bg-opacity-10 drop-shadow-lg">
                        {/* <DataTable
                            title="Product List"
                            theme="defaultLight"
                            columns={columns}
                            data={filteredcasedetails}
                            pagination
                            highlightOnHover
                            selectableRowsHighlight
                            persistTableHead
                            subHeader
                            subHeaderComponent={SubHeader}
                            noDataComponent={'There are no records to display'}
                        /> */}
                        <DataTable title="Order List" theme="defaultLight" columns={columns} data={filteredcasedetails}
                            pagination noHeader highlightOnHover selectableRowsHighlight persistTableHead subHeader
                            expandableRows expandableRowExpanded={(row) => (row.invoiceId === currentRow)} expandableRowsComponent={ExpandComponent} onRowExpandToggled={rowExpanded}
                            subHeaderComponent={SubHeader} onChangePage={val => setPage(val)} paginationDefaultPage={page} noDataComponent={'There are no records to display'} />
                    </motion.div>
                </motion.div>
            }
            <Dialog title={"Update Shipment"} injectClass="w-[350px]" showDialog={openShipmentDialog} onClose={() => setOpenShipmentDialog(false)}>
                <motion.div className="w-full relative flex flex-col">
                    <FieldSelect label={'Shipment Status'} fieldProps={shipForm.getFieldProps('orderStatus')} fieldMeta={shipForm.getFieldMeta('orderStatus')} fieldHelper={shipForm.getFieldHelpers('orderStatus')} edit={true} dataLoaded={true} options={statusMenu} />
                    <motion.div className="w-full relative flex flex-row">
                        <Button injectClass={'bg-white text-black w-32 cursor-pointer ring-1 ring-black rounded-lg'} onClick={() => { shipForm.resetForm(); setOpenShipmentDialog(false) }}>Cancel</Button>
                        <Button injectClass={'bg-black text-white w-32 cursor-pointer ring-1 ring-black rounded-lg'} onClick={() => shipForm.submitForm()}>Save</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
            {/* <Dialog title={"View Order"} showDialog={openViewOrderDialog} onClose={() => setOpenViewOrderDialog(false)}>
                <motion.div className="w-full drop-shadow-lg bg-slate-200 my-2 rounded-xl relative flex flex-col">
                    <motion.div className="w-full h-28 px-2 py-5 items-center justify-between flex flex-row bg-amber-50">
                        <motion.div className="w-96 flex flex-row justify-between">
                            <motion.div className="flex flex-col items-center">
                                <motion.div className="text-xl font-bold">
                                    Order Placed
                                </motion.div>
                                <motion.div className="text-md font-bold">
                                    {orderDetails?.orderPlacedDate}
                                </motion.div>
                            </motion.div>
                            <motion.div className="flex flex-col items-center">
                                <motion.div className="text-xl font-bold">
                                    Total
                                </motion.div>
                                <motion.div className="text-md font-bold">
                                    {orderDetails?.totalAmount / 100}
                                </motion.div>
                            </motion.div>
                            <motion.div className="flex flex-col items-center">
                                <motion.div className="text-xl font-bold">
                                    Ship To
                                </motion.div>
                                <motion.div className="text-md font-bold">
                                    {orderDetails?.name}
                                </motion.div>
                            </motion.div>
                        </motion.div>
                        <motion.div className="flex flex-col w-96">
                            <motion.div className="text-xl font-bold">
                                Order #{orderDetails?.orderId}
                            </motion.div>
                        </motion.div>
                    </motion.div>
                    <motion.div className="flex flex-col">
                        <motion.div className="flex px-2 py-2 flex-row w-full h-full items-center">
                            {orderDetails?.value?.images?.length > 0 && (
                                <img src={orderDetails.value.images[0].imageUrl} height={100} width={100} />
                            )}
                            <motion.div className="flex flex-col px-2 py-2 justify-evenly">
                                <motion.div className="text-xl font-bold my-2">
                                    {orderDetails?.value.productId.productName}&nbsp;/&nbsp;{orderDetails?.value.productId.brandName}&nbsp;/&nbsp;{orderDetails?.value.productId.modelName}
                                </motion.div>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                </motion.div>
            </Dialog> */}
            <Dialog title={"Print Order"} showDialog={openPrintOrderDialog} onClose={() => setOpenPrintOrderDialog(false)}>
                <motion.div id={'invoicePrint'} ref={invoiceRef} className="w-full h-full flex-flex-col relative px-2">
                    <motion.div className="flex flex-row justify-between my-5">
                        <motion.div className="w-32">
                            <img src={logo} alt="logo" />
                        </motion.div>
                        <motion.div className="flex flex-col">
                            <motion.div className="font-bold text-xl">
                                Tax Invoice / Bill of Supply / Cash Memo
                            </motion.div>
                            <motion.div className="text-md flex flex-row items-center justify-center font-medium">
                                (Original for Recipient)
                            </motion.div>
                        </motion.div>
                    </motion.div>
                    <motion.div className="flex flex-row my-5 justify-between">
                        <motion.div className="flex flex-col">
                            <motion.div className="text-lg font-bold">
                                Sold By
                            </motion.div>
                            <motion.div className="text-md flex flex-col font-medium">
                                <span>{accountDetails?.accountName}</span>
                                <span>{accountDetails?.accountAddress?.addressLine1},</span>
                                <span>{accountDetails?.accountAddress?.addressLine2}</span>
                                <span>{accountDetails?.accountAddress?.city},</span>
                                <span>{accountDetails?.accountAddress?.district}-{accountDetails?.accountAddress?.pinCode},</span>
                                <span>{accountDetails?.accountAddress?.state}</span>
                            </motion.div>
                        </motion.div>
                        <motion.div className="flex flex-col">
                            <motion.div className="text-lg font-bold">
                                Billing Address:
                            </motion.div>
                            <motion.div className="text-md flex flex-col text-end font-medium">
                                <span>{orderDetails?.name}</span>
                                <span>{orderDetails?.addressLine1},</span>
                                <span>{orderDetails?.addressLine2}</span>
                                <span>{orderDetails?.city},</span>
                                <span>{orderDetails?.district}-{orderDetails?.pinCode},</span>
                                <span>{orderDetails?.state}</span>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                    <motion.div className="flex flex-col">
                        <motion.div className="flex flex-row">
                            <motion.div className="text-md font-bold">
                                Order Id
                            </motion.div>&nbsp;:&nbsp;
                            <motion.div className="text-md">
                                {orderDetails?.orderId}
                            </motion.div>
                        </motion.div>
                        <motion.div className="flex flex-row">
                            <motion.div className="text-md font-bold">
                                Order Placed Date
                            </motion.div>&nbsp;:&nbsp;
                            <motion.div className="text-md">
                                {orderDetails?.orderPlacedDate}
                            </motion.div>
                        </motion.div>
                    </motion.div>
                    <motion.div className="my-5 flex flex-col">
                        <table>
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Description</th>
                                    <th>Unit Price</th>
                                    <th>Qty</th>
                                    <th>Net Amount</th>
                                    <th>CGST</th>
                                    <th>SGST</th>
                                    <th>Total Amount</th>
                                </tr>
                            </thead>
                            {/* <tbody>
                                <tr className="my-2">
                                    <td>1</td>
                                    <td>{orderDetails?.value.productId.productName}</td>
                                    <td>{orderDetails?.value.productId.price}</td>
                                    <td>{orderDetails?.value.orderQuantity}</td>
                                    <td>{orderDetails?.value.orderQuantity * orderDetails?.value.productId.price}</td>
                                    <td>{orderDetails?.value.productId.cgst}</td>
                                    <td>{orderDetails?.value.productId.sgst}</td>
                                    <td>{(orderDetails?.value.orderQuantity * orderDetails?.value.productId.price) + orderDetails?.value.productId.cgst + orderDetails?.value.productId.sgst}</td>
                                </tr>
                                <tr className="my-2">
                                    <td>2</td>
                                    <td>Shipping Charges</td>
                                    <td>{orderDetails?.value.productId.deliveryCharges}</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>{orderDetails?.value.productId.deliveryCharges}</td>
                                </tr>
                                <tr className="my-2">
                                    <td>3</td>
                                    <td>Coupon Code</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{orderDetails?.totalAmount / 100}</td>
                                </tr>
                                <tr className="my-2">
                                    <td>4</td>
                                    <td>Total</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{orderDetails?.totalAmount / 100}</td>
                                </tr>
                            </tbody> */}
                            <tbody>
                                {printOrders && printOrders?.productDetails?.length && printOrders?.productDetails?.map((product, index) => {
                                    return <tr className="my-2">
                                        <td>{index + 1}</td>
                                        <td>{product?.productId.productName}</td>
                                        <td>{product?.productId.price}</td>
                                        <td>{product?.orderQuantity}</td>
                                        <td>{product?.orderQuantity * product?.productId.price}</td>
                                        <td>{product?.productId.cgst}</td>
                                        <td>{product?.productId.sgst}</td>
                                        <td>{(product?.orderQuantity * product?.productId.price) + product?.productId.cgst + product?.productId.sgst}</td>
                                    </tr>
                                })}
                                <tr className="my-2">
                                    <td></td>
                                    <td>Coupon Code</td>
                                    <td colSpan={5}>{printOrders?.couponDetails?.couponCode}</td>
                                    <td>{printOrders?.couponDetails?.couponId?.percentage}%</td>
                                </tr>
                                <tr className="my-2">
                                    <td></td>
                                    <td>Total</td>
                                    <td colSpan={5}></td>
                                    <td>{parseInt(printOrders?.orderDetails?.totalAmount) / 100}</td>
                                </tr>
                            </tbody>
                        </table>
                    </motion.div>
                    <motion.div className="flex flex-row justify-end">
                        <Button injectClass={'bg-primeColor/40 text-black rounded-lg hover:bg-primeColor hover:text-white cursor-pointer font-bold ring-1 ring-black'} onClick={() => handlePrint()}>Print</Button>
                    </motion.div>
                </motion.div>
            </Dialog >
        </>
    )
}

export default StoreOrders